import { OrderDetailPage } from '@/components/orders/OrderDetailPage';

export function AnonymousOrdersDetailPage() {
  return <OrderDetailPage isMember={false} />;
}
